<template>
<div style="margin-top: 10px">

  <div>
    <el-descriptions :border="true" :column="3" title="基本信息">
      <!-- 顶部操作按钮 -->
      <template slot="extra">
        <div style="display: flex; gap: 10px;">
          <el-button @click="$router.back()" size="small">
            <i class="el-icon-arrow-left"></i>返回
          </el-button>
          <el-button type="primary" size="small" @click="address" icon="el-icon-position">地址管理</el-button>
          <el-button type="primary" size="small" @click="handleEdit" icon="el-icon-edit">客户编辑</el-button>
          <el-button type="primary" size="small" @click="placeOrder" icon="el-icon-bank-card">创建订单</el-button>
          <el-button type="primary" size="small" @click="underway" icon="el-icon-notebook-1">客户跟进</el-button>
          <el-button v-perm="'customMycustom/del'" type="primary" size="small"
                     @click="handleDel"><i class="el-icon-delete"/>客户删除
          </el-button>
        </div>
      </template>

      <!-- 基本文字信息，三列排布 -->
      <el-descriptions-item label="公司">{{ showForm.companyName }}</el-descriptions-item>
      <el-descriptions-item label="客户姓名">{{ showForm.customerName }}</el-descriptions-item>
      <el-descriptions-item label="归属人">{{ showForm.salesMan.adminName }}</el-descriptions-item>
      <el-descriptions-item label="客户微信">{{ showForm.customerWx }}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{ formattedPhoneNumber }}</el-descriptions-item>
      <el-descriptions-item label="电话号">
    <span v-for="(phone, index) in showForm.telPhone" :key="index" style="margin-right: 8px;">
      {{ phone }}
    </span>
      </el-descriptions-item>
      <el-descriptions-item label="所属地区">{{ showForm.area }}</el-descriptions-item>
      <el-descriptions-item label="详细地址">{{ showForm.address }}</el-descriptions-item>
      <el-descriptions-item label="录入时间">{{ showForm.entryCustomerTime }}</el-descriptions-item>
      <el-descriptions-item label="修改时间">{{ showForm.updateTime }}</el-descriptions-item>
      <el-descriptions-item label="客户销售渠道">{{ showForm.type.customerType }}</el-descriptions-item>
      <el-descriptions-item label="客户级别">{{ showForm.label.customerLabel }}</el-descriptions-item>
      <el-descriptions-item label="客户来源">{{ showForm.source.customerSource }}</el-descriptions-item>
      <el-descriptions-item label="累计成交次数">{{ showForm.totalDealCount }} 次</el-descriptions-item>
      <el-descriptions-item label="下单产品数量">{{ showForm.orderProductCount }} 箱</el-descriptions-item>
      <el-descriptions-item label="累计金额">{{ showForm.totalAmount }} 元</el-descriptions-item>
      <el-descriptions-item label="最近下单时间">{{ showForm.lastDealTime }}</el-descriptions-item>
      <el-descriptions-item label="备注信息" :span="3">
        <div style="white-space: pre-wrap;">{{ showForm.notes }}</div>
      </el-descriptions-item>
      <!-- 图片独占一行 -->
 <el-descriptions-item label="客户图片" :span="3">
  <div v-for="(url, index) in showForm.picture" :key="index" style="display: inline-block; margin-right: 10px;">
    <el-image
        :src="url"
        fit="cover"
        :preview-src-list="showForm.picture"
        style="width: 120px; height: 120px; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
    />
  </div>
</el-descriptions-item>
    </el-descriptions>



      <!-- 备注信息独占一行 -->


    <h3>
      订单记录
<!--      <span class="subtitle">审核已通过的订单</span>-->
    </h3>
    <el-table :data="acquisitionOrders" highlight-current-row
              style="width: 100% " border max-height="500"
              @expand-change="handleExpandChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div style="padding-left: 10px;"> <!-- 添加一个容器并设置内边距 -->
              <el-table :data="props.row.products" style="width: 100%;" stripe >
                <el-table-column prop="productName" :align="'center'"label="产品名称" />
                <el-table-column prop="productImage" :align="'center'"label="产品图片">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.picture" fit="cover" style="width: 100px; height: 100px" />
                  </template>
                </el-table-column>
                <el-table-column prop="price" :align="'center'" label="产品价格" />
                <el-table-column prop="costPrice" :align="'center'" label="售价" />
                <el-table-column prop="salePrice" :align="'center'" label="成交价" />
                <el-table-column prop="orderNum" :align="'center'" label="成交数量" />
                <el-table-column prop="orderAmount" :align="'center'" label="金额" />
              </el-table>
            </div>
          </template>
        </el-table-column>
      <el-table-column prop="orderSn" label="订单号" width="150" :header-align="'center'" :align="'center'">
        <template slot-scope="scope">
          <span style="color: red;"  @click="handlePass(scope.row.orderSn)">{{ scope.row.orderSn }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="employee.adminName" label="归属人"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="orderAmount" label="订单金额"  sortable :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="payType" label="支付方式"  :header-align="'center'" :align="'center'">
      </el-table-column>
      <el-table-column prop="createTime" label="下单时间"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="logisticsMethods" label="物流方式"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="logisticsCompanies" label="物流公司"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="trackingNumber" label="物流单号"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>
      <el-table-column prop="orderState" label="订单状态"  :header-align="'center'" :align="'center'">
        <template scope="scope">
          <span v-if="scope.row.orderState == 3" style="color: orange">待发货</span>
          <span v-if="scope.row.orderState == 4" style="color: #50bfff">已发货</span>
          <span v-if="scope.row.orderState == 5" style="color: lightgreen">交易成功</span>
          <span v-if="scope.row.orderState == 6" style="color: lightcoral">订单取消</span>
          <span v-if="scope.row.orderState == 0" style="color: lightcoral">待审核</span>
          <span v-if="scope.row.orderState == 1" style="color: lightcoral">待复审</span>
          <span v-if="scope.row.orderState == 2" style="color: lightcoral">审核未通过</span>
          <span v-if="scope.row.orderState == 7" style="color: lightcoral">待终审</span>
        </template>
      </el-table-column>
      <el-table-column prop="lastOperationTime" label="最后操作时间"  :header-align="'center'"
                       :align="'center'">
      </el-table-column>

    </el-table>
    <h3>活跃记录</h3>
    <el-table :data="displayedRecords" style="width: 100%" border>
      <el-table-column label="回访时间" prop="date" width="200" :header-align="'center'" :align="'center'">
      </el-table-column>
      <el-table-column label="跟进记录" :header-align="'center'">
        <template slot-scope="scope">
          <div v-if="scope.row.recordType === 1">
            <el-tooltip effect="light" content="详情请查看上面订单记录">
            <el-button type="text" >{{ scope.row.content }}</el-button>
            </el-tooltip>
          </div>
          <div v-else>
            <span class="content-wrap">{{ scope.row.content }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作人" prop="console.adminName" width="200" :header-align="'center'" :align="'center'">
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 20px;">
      <el-button
          v-if="displayedRecords.length < followUpForm.length"
          @click="loadMoreData"
          :loading="loading"
          style="position: relative;"
      >
        加载更多
        <div v-if="loading" class="loading-overlay"></div>
      </el-button>
    </div>
  </div>

  <el-dialog
      title="客户跟进"
      :visible.sync="underwayVisible"
      :close-on-click-modal="false"
      width="45%"
  >
    <el-form :model="showForm" ref="showForm" >
      <el-form-item label="客户跟进">
        <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入与客户的跟进记录"
            v-model="showForm.content"
            class="input-field"
        />
      </el-form-item>
      <div class="button-container">
        <el-button type="primary" @click="follow" >
          添加跟进记录
        </el-button>
        <el-button @click="underwayVisible = false" >
          取消
        </el-button>
      </div>
    </el-form>
  </el-dialog>

  <el-drawer
      title="客户编辑"
      :visible.sync="editFormVisible"
      size="60%"
      direction="rtl"
      @close="closeEditPage"
  >
    <div class="edit-form-container">
      <el-form :model="editForm" label-width="130px" :rules="editFormRules" ref="editForm">
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item prop="customerName">
                <template #label>
                  客户名称 <i class="el-icon-user icon-size"></i>
                </template>
                <el-input v-model="editForm.customerName" auto-complete="off" placeholder="请输入客户名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="companyName">
                <template #label>
                  公司名称 <i class="el-icon-office-building icon-size"></i>
                </template>
                <el-input v-model="editForm.companyName" auto-complete="off" placeholder="请输入公司名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="phoneNumber">
              <template #label>手机号 <i class="el-icon-mobile-phone icon-size"></i></template>
              <el-input maxlength="11" show-word-limit v-model="editForm.phoneNumber" auto-complete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sourceId">
              <template #label>客户来源 <i class="el-icon-position icon-size"></i></template>
              <el-select v-model="editForm.sourceId" placeholder="请选择客户来源" style="width: 100%">
                <el-option v-for="item in custoSource" :key="item.id" :label="item.customerSource" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="labelId">
              <template #label>客户级别 <i class="el-icon-star-off icon-size"></i></template>
              <el-select v-model="editForm.labelId" placeholder="请选择客户级别" style="width: 100%">
                <el-option v-for="item in custoLabel" :key="item.id" :label="item.customerLabel" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="typeId">
              <template #label>销售渠道 <i class="el-icon-shopping-cart-full icon-size"></i></template>
              <el-select v-model="editForm.typeId" placeholder="请选择销售渠道" style="width: 100%">
                <el-option v-for="item in custoType" :key="item.id" :label="item.customerType" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <div class="section-title">地址信息</div>

        <el-form-item prop="area">
          <template #label>
            所属地区 <i class="el-icon-map-location icon-size" />
          </template>
          <el-cascader
            style="width: 100%"
            :options="pcaTextArr"
            v-model="editForm.area"
            placeholder="请选择所属地区">
          </el-cascader>
        </el-form-item>

        <el-form-item prop="address">
          <template #label>
            详细地址 <i class="el-icon-location-information icon-size"></i>
          </template>
          <el-input v-model="editForm.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
        </el-form-item>
      </div>

      <div class="form-section">
        <div class="section-title">联系方式</div>

        <el-form-item label="客户电话">
          <template #label>
            客户电话 <i class="el-icon-phone-outline icon-size"></i>
          </template>
          <div class="phone-list">
            <div v-for="(phone, index) in editForm.telPhone" :key="index" class="phone-item">
              <el-input
                  v-model="editForm.telPhone[index]"
                  auto-complete="off"
                  maxlength="11"
                  show-word-limit
                  placeholder="请输入客户电话">
              </el-input>
              <el-button type="danger" icon="el-icon-delete" circle @click="removePhone(index)" v-if="editForm.telPhone.length > 1"></el-button>
              <el-button type="primary" icon="el-icon-plus" circle @click="addInput(index)" v-if="index === editForm.telPhone.length - 1"></el-button>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注信息">
          <template #label>
            备注信息 <i class="el-icon-document icon-size" />
          </template>
          <el-input
            type="textarea"
            :rows="3"
            v-model="editForm.notes"
            auto-complete="off"
            placeholder="请输入备注信息">
          </el-input>
        </el-form-item>
      </div>

      <div class="form-section">
        <div class="section-title">附件信息</div>

        <div class="image-section">
          <div class="image-title">
            <i class="el-icon-picture-outline icon-size"></i> 客户图片
          </div>
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="image-preview-container">
                <div v-if="editForm.picture && editForm.picture.length > 0" class="image-grid">
                  <div v-for="(pic, index) in editForm.picture"
                       :key="index"
                       class="image-item">
                    <el-image
                        class="edit_show_image"
                        :src="pic"
                        fit="cover">
                      <div slot="error" class="image-error">图片加载失败</div>
                    </el-image>
                    <!-- 优化后的删除按钮 -->
                    <i class="el-icon-close delete-icon" @click="deleteImage(index)"></i>
                  </div>

                </div>
                <div v-else class="image-placeholder">
                  暂无图片
                </div>
              </div>
              <el-upload
                  ref="uploadEdit"
                  class="upload-demo"
                  name="file"
                  :action="this.$uploadURL"
                  :on-remove="handleFileRemove"
                  :on-success="handleFileUploadedit"
                  :on-exceed="handleFileExceed"
                  :file-list="fileList"
                  :limit="5"
                  accept=".jpg,.png,.gif,.qlv"
                  list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>

            </el-col>

          </el-row>
        </div>
      </div>
      </el-form>

      <!-- footer 操作按钮 -->
      <div class="drawer-footer">
        <el-button @click="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </div>
  </el-drawer>

  <customer-address
      :visible.sync="addressVisible"
      :customer-id="customerId">
  </customer-address>
</div>

</template>

<script>
import { Loading } from 'element-ui'; // 导入 Element UI 的 Loading 组件
import {pcaTextArr} from "element-china-area-data";
export default {
  name:'customerDetail',
data(){
  return{
    //客户编辑
    editFormVisible: false,
    editLoading: false,
    fileList:[],
    editForm: {
      companyName: '',
      customerName: '',
      phoneNumber: '',
      address: '',
      labelId: '',
      typeId: '',
      sourceId: '',
      picture: [],
      notes: '',
      telPhone:[''],
      area:[],
    },
    editFormRules: {
      typeId: [
        {required: true, message: '请输入客户销售渠道', trigger: 'blur'}
      ],
      labelId: [
        {required: true, message: '请输入客户级别', trigger: 'blur'}
      ],
      sourceId: [
        {required: true, message: '请输入客户来源', trigger: 'blur'}
      ],
      companyName: [
        {required: true, message: '请输入公司名称', trigger: 'blur'}
      ],
      customerName: [
        {required: true, message: '请输入客户名称', trigger: 'blur'}
      ],
    },
    salesMans: [],
    // 客户级别
    custoLabel: [],
    // 客户销售渠道
    custoType: [],
    //客户来源
    custoSource: [],

    addressVisible: false,

    //描述组件
    labelstyle:{
      'width':'17vh',
    },
    contentStyle: {
      width: '25vh', // 设置内容的宽度
    },


    //手机号
    currentPhoneIndex: null,
    topItemId: null,// 用于标记置顶项的ID
    tableMaxHeightOffset: 100, // 根据需求调整这个偏移量
    isPhoneNumberVisible: false, // 表单中手机号是否可见
    clickCount: 0, // 当天已点击次数
    maxClicksPerDay: 100, // 每天最大点击次数
    lastReset: null, // 上次重置点击次数的时间
    //订单记录
    acquisitionOrders: [],//所有订单
    showFormVisible:false,
    ordercustomerId:'',
    //订单展开的产品信息
    expandedOrderSn: null,  // 当前展开的订单号
    productList: [],  // 当前展开的订单的产品列表
    //活跃记录
    followUpForm: {
      date: '',
      content: '',
    },
    displayedRecords: [], // 当前显示的数据
    recordsToShow: 5,// 每次加载的数据行数
    loading: false, // 加载状态
    //新加回访记录
    underwayVisible:false,
    //基本数据
    listLoding:false,
    showForm: {
      type: {},
      label:{},
      source:{},
      picture:['https://th.bing.com/th/id/R.df6b255366ba0aad52c6f775195fcbbe?rik=7f0%2bOLJHSx0s3w&riu=http%3a%2f%2fpic.616pic.com%2fbg_w1180%2f00%2f13%2f34%2f4VFVYpRVLA.jpg!%2ffw%2f1120&ehk=f6Vj9tdnLEdF0IzGZsuSeaOyVDyB0gLPWDgTuDMWGyQ%3d&risl=&pid=ImgRaw&r=0'],

    },
     customerId:'',
    // 编辑表单相关数据

    pcaTextArr,
  }
},
  computed: {
    // 计算当前表单中的手机号
    formattedPhoneNumber() {
      return this.isPhoneNumberVisible
          ? this.showForm.phoneNumber
          : this.formatPhoneNumber(this.showForm.phoneNumber);
    },
  },
  methods:{
    handleDel: function () {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete("/customMycustom/" + this.customerId).then(res => {
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            },
            );

            localStorage.removeItem('lastCustomerId');
            this. $router.back();
          } else {
            this.$message.warning("该客户信息存在订单信息，禁止删除！");
          }
        }).catch(res => {
          this.$message.warning("系统繁忙，请稍后重试!!!")
        })
      }).catch(() => {
      });
    },
    getType() {
      this.$http.get("/customerType").then(res => {
        this.custoType = res.data;
      })
    },
    //获取标签
    getLabel() {
      this.$http.get("/customerLabel").then(res => {
        this.custoLabel = res.data;
      })
    },
    //获取来源
    getSerouce() {
      this.$http.get("/customerSource").then(res => {
        this.custoSource = res.data;
      })
    },

    addInput(index) {
      this.editForm.telPhone.splice(index + 1, 0, '');
    },
    removePhone(index) {
      this.editForm.telPhone.splice(index, 1);
    },

    // 删除图片
    deleteImage(index) {
      this.$confirm('确定要删除这张图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 直接从数组中移除图片
        this.editForm.picture.splice(index, 1)
        this.$message.success("图片删除成功")
      }).catch(() => {
        // 用户点击取消，不做处理
      })
    },


    closeEditPage() {
      this.editFormVisible = false;
    },

    handleEdit: function (index, row) {
      const tempForm = JSON.parse(JSON.stringify(this.showForm));

      // 处理图片数组
      if (typeof tempForm.picture === 'string') {
        tempForm.picture = tempForm.picture ? tempForm.picture.split(',') : [];
      } else if (!Array.isArray(tempForm.picture)) {
        tempForm.picture = [];
      }

      // 处理电话回显：如果是字符串就转成数组，为空则给一个空位
      if (typeof tempForm.telPhone === 'string') {
        tempForm.telPhone = tempForm.telPhone ? tempForm.telPhone.split(',') : [''];
      } else if (!Array.isArray(tempForm.telPhone) || tempForm.telPhone.length === 0) {
        tempForm.telPhone = [''];
      }

      // 处理地区回显：如果是字符串就转成数组
      if (typeof tempForm.area === 'string') {

        if (tempForm.area.includes(',')) {
          tempForm.area = tempForm.area.split(',');
        }
        // 假设存的是 "浙江省/杭州市/西湖区"
        else if (tempForm.area.includes('/')) {
          tempForm.area = tempForm.area.split('/');
        }
        else {
          tempForm.area = [tempForm.area];
        }
      }

      // 删除后端维护的时间字段
      delete tempForm.updateTime;
      delete tempForm.entryCustomerTime;
      delete tempForm.lastDealTime;

      this.editForm = Object.assign({}, tempForm);
      this.editFormVisible = true;
      this.getType();
      this.getLabel();
      this.getSerouce();
    },


    //文件删除时的回调
    handleFileRemove(file, fileList) {
      //正式删除
      var fileName = null;
      if (file.response) {  //上传图片的时候点了删除
        fileName = file.response.resultObj;
      } else {  //点击修改回显的图片，点了删除
        fileName = file.url;
      }
      //为了方便参数传递,需要转换路径写法,把/替换为_
      fileName = fileName.replaceAll("/", "_");
      //发送请求
      this.$http.delete("/minio/" + fileName).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.fileList = fileList;
          // 从editForm.picture数组中移除已删除的图片
          if (file.response) {
            const index = this.editForm.picture.indexOf(file.response.resultObj);
            if (index !== -1) {
              this.editForm.picture.splice(index, 1);
            }
          } else {
            const index = this.editForm.picture.indexOf(file.url);
            if (index !== -1) {
              this.editForm.picture.splice(index, 1);
            }
          }
        } else {
          this.$message.error("删除失败");
        }
      })
    },

    //文件上传成功之后的修改页面回调
    handleFileUploadedit(response) {
      if (response.success) {
        this.editForm.picture.push(response.resultObj);
      }
    },

    //上传超过数量的回调
    handleFileExceed() {
      this.$message.error("最多只能上传5张图片");
    },

    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true;
            const logininfo = JSON.parse(localStorage.getItem("logininfo"));
            this.editForm.loginId = logininfo.id;
            let para = Object.assign({}, this.editForm);
            para.telPhone = para.telPhone ? para.telPhone.filter(phone => phone !== '').join(',') : '';
            para.picture = para.picture ? para.picture.join(',') : '';
            para.area = para.area ? para.area.join('/') : ''
            this.$http.put("/customMycustom", para).then(res => {
              if (res.data.success) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
              } else {
                this.$message.error("系统繁忙，请稍后重试!!!【500】");
              }
              this.editLoading = false;
              this.editFormVisible = false;
              this.$refs.uploadEdit.clearFiles()
              this.getcustomerLists();

            });
          });
        }
      });
    },
    //文件上传成功之后的回调
    handleFileUpload(response) {
      if (response.success) {
        this.addForm.picture.push(response.resultObj);
      }
    },
      address(){
        this.addressVisible = true;
      },

    //手机号隐藏
    //小于2位不隐藏,6位隐藏中间的两位,大于6位隐藏中间的4位
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber ) {
        return '';
      }
      const length = phoneNumber.length;
      if (length <= 2) {
        return phoneNumber;
      } else if (length > 2 && length < 6) {
        return phoneNumber.slice(0, 2) + '**' + phoneNumber.slice(4);
      } else if (length >= 6) {
        return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(length - 2, length);
      }
      return phoneNumber;
    },
    // 切换电话号码的显示状态
    togglePhoneNumber(index) {
      if (this.currentPhoneIndex === index) {
        this.currentPhoneIndex = null;
      } else {
        this.currentPhoneIndex = index;
      }
    },
    // 判断是否应该显示按钮
    shouldShowButton(phoneNumber) {
      if(!phoneNumber){
        return ''
      }
      return phoneNumber.length > 2;
    },
    // 处理电话号码按钮点击事件
    handlePhoneNumberClick(index) {
      this.resetClicksIfNeeded();
      if (this.clickCount < this.maxClicksPerDay) {
        this.togglePhoneNumber(index);
        this.clickCount++;
        this.saveClickData();
      } else {
        // 如果超过当天最大点击次数，显示提示信息
        this.$notify({
          title: '提示',
          message: '当前已没有查看次数，请明天再来',
          type: 'warning',
        });
      }
    },
    // 切换表单电话号码的显示状态
    toggleFormPhoneNumber() {
      this.isPhoneNumberVisible = !this.isPhoneNumberVisible;
    },
    // 处理表单中电话号码按钮点击事件
    handleFormPhoneNumberClick() {
      this.resetClicksIfNeeded();
      if (this.clickCount < this.maxClicksPerDay) {
        this.toggleFormPhoneNumber();
        this.clickCount++;
        this.saveClickData();
      } else {
        // 如果超过当天最大点击次数，显示提示信息
        this.$notify({
          title: '提示',
          message: '当前已没有查看次数，请明天再来',
          type: 'warning',
        });
      }
    },
    // 从localStorage加载点击次数数据
    loadClickData() {
      const storedClickCount = localStorage.getItem('clickCount');
      const storedLastReset = localStorage.getItem('lastReset');

      this.clickCount = storedClickCount ? parseInt(storedClickCount, 10) : 0;
      this.lastReset = storedLastReset ? new Date(storedLastReset) : new Date();
    },
    // 将点击次数数据保存到localStorage
    saveClickData() {
      localStorage.setItem('clickCount', this.clickCount);
      localStorage.setItem('lastReset', this.lastReset.toISOString());
    },
    // 检查是否需要重置点击次数
    resetClicksIfNeeded() {
      const now = new Date();
      const lastResetTime = new Date(this.lastReset);

      // 将 lastResetTime 调整到当天的 0:00:00
      lastResetTime.setHours(0, 0, 0, 0);

      // 如果当前时间已经过了 lastResetTime 的 24 小时
      if (now.getTime() - lastResetTime.getTime() >= 24 * 60 * 60 * 1000) {
        this.clickCount = 0;
        this.lastReset = now;
        this.saveClickData();
      }
    },
//获取客户数据信息
    getcustomerLists() {
      const customerId = this.customerId;
      this.$http.get('/customMycustom/getCustomerDetail/' + customerId)
          .then((res) => {
            // 处理 res.data 对象
            const data = res.data;

            // 转换图片和电话号字段为数组
            data.picture = data.picture ? data.picture.split(',') : [];
            data.telPhone = data.telPhone ? data.telPhone.split(',') : [];

            // 格式化时间字段
            data.updateTime = this.$formatTimeNew(data.updateTime);
            data.entryCustomerTime = this.$formatTimeNew(data.entryCustomerTime);
            data.lastDealTime = this.$formatTimeNew(data.lastDealTime);

            // 将处理后的数据赋值给 showForm
            this.showForm = data;
          });
    },
    //获取订单列表
    getAcquisitionOrders() {
      let para = {
        currentPage: 1,
        pageSize: 500,
        ordercustomerId: this.customerId,
      };
      this.$http.post("/orderList/getCustomerOrder", para).then(res => {
        this.acquisitionOrders = res.data.records.map(order => ({
          ...order,
          receipt: order.receipt ? order.receipt.split(',') : [],
          voucher: order.voucher ? order.voucher.split(',') : []
        }));
      }).catch(result => {
        this.$message.error("系统繁忙，请稍后重试!!!")
      })
    },
    // 处理关闭抽屉事件
    handleDrawerClose() {
      this.isPhoneNumberVisible = false;
    },

    //获取订单产品信息
    showOrderDetail(order){
      this.$http.post("/orderProducid/" + order.orderSn).then(res => {
        // 将获取到的产品列表存储在对应订单的 products 属性中
        this.$set(order, 'products', res.data);
      });
    },
    //展开产品信息处理
    handleExpandChange(row) {
      if (!row.products) {
        // 仅当订单的产品信息尚未获取时调用 showOrderDetail 方法
        this.showOrderDetail(row);
      }
    },
    //打开回访页面
    underway(){
      this.underwayVisible=true;
    },
    follow: function () {
      this.$refs.showForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
                const logininfo = JSON.parse(localStorage.getItem("logininfo"));
                const LoginInfoId = logininfo.id;
                let para = {
                  customId: this.customerId,//客户id
                  content: this.showForm.content,
                  loginInfoId: LoginInfoId,
                };
                this.$http.put("/customReturnVisit/follow", para).then(res => {
                  if (res.data.success) {
                    this.$message({
                      message: '客户回访信息提交成功',
                      type: 'success'
                    });
                    this.underwayVisible=false;
                  } else {
                    this.$message.error("系统繁忙，请稍后重试!!!");
                  }
                  this.allFollowUp();
                });
              }
          );
        }
      });
    },
    // 加载更多数据
    loadMoreData() {
      this.loading = true; // 开始加载
      const currentLength = this.displayedRecords.length;
      const additionalRecords = this.followUpForm.slice(
          currentLength,
          currentLength + this.recordsToShow
      );
      setTimeout(() => {
        this.displayedRecords = this.displayedRecords.concat(additionalRecords);
        this.loading = false; // 结束加载
      }, 500); // 模拟延迟
    },
    //获取活跃记录数据
    allFollowUp: function () {
      const customId = this.customerId
      this.$http.get("/customReturnVisit/" + customId).then(res => {
        this.followUpForm = res.data;
        // 初始化显示的记录
        this.displayedRecords = this.followUpForm.slice(0, this.recordsToShow);
      })
    },
    //订单详情
    handlePass(orderSn){
      // 使用编程式导航跳转到审核页面，并携带订单编号
      this.$router.push({ name: '订单详情', params: { orderSn: orderSn } });
    },
    //跳转到创建订单
    placeOrder: function (index) {
      this.$confirm(`确定要创建订单吗？`, '确认下单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击了确定按钮，执行下单操作
        //跳转到创建订单
        const customerId = this.customerId;
        const customerName = this.showForm.customerName;
        const customerType = this.showForm.type.customerType;
        const customerLabel = this.showForm.label.customerLabel;
        const customerSource = this.showForm.source.customerSource;

        this.$router.push({
          name: '客户订单',
          params: {
            orderData: {
              customerId: customerId,
              customerName: customerName,
              customerType: customerType,
              customerSource: customerSource,
              customerLabel: customerLabel,

            }
          }
        });
      }).catch(() => {
        // 用户点击了取消按钮，不执行下单操作
      });
    },
  },

  mounted() {
    const routeCustomerId = this.$route.params.customerId; // 从路由参数获取客户ID
    if (routeCustomerId) {
      // 如果路由参数中有客户ID，则存储到localStorage并使用该ID
      localStorage.setItem('lastCustomerId', routeCustomerId);
      this.customerId = routeCustomerId;
    } else {
      const storedCustomerId = localStorage.getItem('lastCustomerId'); // 从localStorage获取客户ID
      if (storedCustomerId) {
        // 如果路由参数中没有客户ID，但localStorage中有，则使用localStorage中的ID
        this.customerId = storedCustomerId;
      } else {
        // 如果两者都没有，则跳转到客户列表页面
        this.$router.push({name: '我的客户'});
        return; // 确保后续代码不会执行
      }
    }
    this.getcustomerLists();
    this.getAcquisitionOrders();
    this.allFollowUp();
  }
}

</script>

<style scoped>
h3 {
  margin-left: 10px;
}

.subtitle {
  font-size: 10px;
  color: #999;
  margin-left: 10px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 15px 20px;
  background: #ffffff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
  box-sizing: border-box;
  display: flex;
  justify-content:center;
  gap: 12px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 100;
}

.edit-form-container {
  padding: 20px 24px;
  padding-bottom: 80px;
  height: calc(100% - 10px);
  overflow-y: auto;
}

.edit-form-container::-webkit-scrollbar {
  width: 6px;
}

.edit-form-container::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.edit_show_image {
  max-width: 100%;
  max-height: 150px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  background-color: #f9f9f9;
  box-sizing: border-box;
}

.image-placeholder {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  color: #999;
  background-color: #fafafa;
}

.icon-size {
  font-size: 16px;
  margin-left: 5px;
  color: #606266;
}

.phone-list {
  width: 100%;
}

.phone-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.phone-item:last-child {
  margin-bottom: 0;
}

.el-form-item {
  margin-bottom: 22px;
}

/deep/ .el-form-item__label {
  font-weight: 500;
  color: #333;
}

/deep/ .el-input__inner,
/deep/ .el-textarea__inner {
  border-radius: 4px;
}

/deep/ .el-select .el-input__inner {
  cursor: pointer;
}

/deep/ .el-cascader .el-input__inner {
  cursor: pointer;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .el-row {
    flex-direction: column;
  }

  .el-col {
    width: 100%;
    margin-bottom: 15px;
  }

  .phone-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .phone-item .el-input {
    width: 100% !important;
    margin-bottom: 10px;
  }

  .phone-item .el-button {
    align-self: flex-end;
  }
}

/* 表单布局优化 */
.edit-form-container .el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.edit-form-container .el-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* 图片上传区域优化 */
.upload-demo {
  width: 100%;
}

.upload-demo ::v-deep .el-upload-list--picture {
  width: 100%;
}

.upload-demo ::v-deep .el-upload-list__item {
  width: 100%;
}

/* 图片区域美化 */
.image-section {
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
  margin-top: 10px;
}

.image-title {
  font-weight: 500;
  color: #333;
  margin-bottom: 15px;
  font-size: 14px;
}

.image-preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 表单分区样式 */
.form-section {
  margin-bottom: 20px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

/* 图片网格布局 */
.image-grid {
  display: flex;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 5px;
  width: 100%;
}



.delete-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 12px;
}

.image-item {

  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.edit_show_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.delete-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 16px;
  color: #fff;
  background: rgba(0,0,0,0.4);
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: background 0.2s;
  display: none; /* 默认不显示 */
}

.image-item:hover .delete-icon {
  display: block; /* 鼠标悬浮才显示 */
}

.delete-icon:hover {
  background: rgba(255,0,0,0.7);
}





</style>



// WEBPACK FOOTER //
// customerDetail.vue?0d7a583f